import * as tslib_1 from "tslib";
import openCompose from './openCompose';
import trySaveAndCloseCompose from './trySaveAndCloseCompose';
import { getStore } from '../store/composeStore';
import ComposeTarget from '../store/schema/ComposeTarget';
import { HTML_BODY_TYPE } from '../utils/getDefaultBodyType';
import isEncryptionFeatureEnabled from '../utils/isEncryptionFeatureEnabled';
import isTabViewEnabled from 'owa-tab-store/lib/utils/isTabViewEnabled';
import getItem from 'owa-mail-store/lib/services/getItem';
import checkIfResponseSuccess from 'owa-mail-store/lib/services/utils/checkIfResponseSuccess';
import { getComposeItemResponseShape } from 'owa-mail-store/lib/utils/getItemResponseShape';
import { getStore as getTabStore, lazyActivateTab, TabType } from 'owa-tab-store';
import { action } from 'satcheljs/lib/legacy';
export default action('loadDraftToCompose')(function loadDraftToCompose(itemId, openTarget) {
    if (openTarget === void 0) { openTarget = ComposeTarget.SecondaryTab; }
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var openInTab, state, tabStore, _i, _a, tab, shape, response, responseMessage, message, bodyType, composeInitProps;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    openInTab = isTabViewEnabled() && openTarget === ComposeTarget.SecondaryTab;
                    if (!!openInTab) return [3 /*break*/, 2];
                    if (openTarget == ComposeTarget.SecondaryTab) {
                        // Can't open in tab, fallback to primary reading pane
                        openTarget = ComposeTarget.PrimaryReadingPane;
                    }
                    return [4 /*yield*/, trySaveAndCloseCompose(null /*viewState*/)];
                case 1:
                    _b.sent();
                    state = getStore();
                    if (state.defaultViewState) {
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    tabStore = getTabStore();
                    for (_i = 0, _a = tabStore.tabs; _i < _a.length; _i++) {
                        tab = _a[_i];
                        if (tab.type == TabType.Compose && tab.data.itemId && tab.data.itemId.Id == itemId) {
                            lazyActivateTab.importAndExecute(tab);
                            return [2 /*return*/];
                        }
                    }
                    _b.label = 3;
                case 3:
                    shape = getComposeItemResponseShape(null /*bodyType*/);
                    return [4 /*yield*/, getItem([itemId], shape, 'MailCompose')];
                case 4:
                    response = _b.sent();
                    if (!checkIfResponseSuccess(response[0])) return [3 /*break*/, 6];
                    responseMessage = response[0];
                    message = responseMessage.Items[0];
                    bodyType = message.Body.BodyType == HTML_BODY_TYPE ? 'HTML' : 'Text';
                    composeInitProps = {
                        operation: 4 /* EditDraft */,
                        bodyType: bodyType,
                        itemId: message.ItemId,
                        subject: message.Subject,
                        quotedBody: message.Body.Value,
                        to: message.ToRecipients,
                        cc: message.CcRecipients,
                        bcc: message.BccRecipients,
                        attachments: message.Attachments,
                        importance: message.Importance,
                        preferAsyncSend: true,
                        from: message.From != null ? message.From.Mailbox : null,
                        pendingSocialActivityTags: message.PendingSocialActivityTagIds,
                        IRMData: isEncryptionFeatureEnabled() ? message.RightsManagementLicenseData : null,
                    };
                    return [4 /*yield*/, openCompose(composeInitProps, openTarget, null)];
                case 5:
                    _b.sent();
                    _b.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=loadDraftToCompose.js.map